export default "/static/build/story-steps.webp";